import { render, staticRenderFns } from "./user_profile.vue?vue&type=template&id=70cc2432&scoped=true&"
import script from "./user_profile.vue?vue&type=script&lang=js&"
export * from "./user_profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cc2432",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70cc2432')) {
      api.createRecord('70cc2432', component.options)
    } else {
      api.reload('70cc2432', component.options)
    }
    module.hot.accept("./user_profile.vue?vue&type=template&id=70cc2432&scoped=true&", function () {
      api.rerender('70cc2432', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/shared/user/modal/user_profile.vue"
export default component.exports